// Serialize a JSON-LD payload for embedding in a
// <script type="application/ld+json"> via dangerouslySetInnerHTML.
//
// JSON.stringify does NOT escape `<`, `>`, or the U+2028/U+2029 line
// separators, so a value that ever contains the literal `</script>` (or those
// separators) would break out of the script element and could execute. Today
// every JSON-LD payload is built from static/in-repo content, so this is
// defense-in-depth - but escaping keeps it safe if authored dossier/FAQ copy
// ever grows a stray `</script>`. The escaped output is still valid JSON that
// JSON-LD parsers read identically.

// Matches <, >, U+2028, U+2029; built from char codes so the source is ASCII.
const JSONLD_UNSAFE = new RegExp(
  '[<>' + String.fromCharCode(0x2028) + String.fromCharCode(0x2029) + ']',
  'g',
);

export function serializeJsonLd(payload: unknown): string {
  return JSON.stringify(payload).replace(
    JSONLD_UNSAFE,
    (c) => '\\u' + c.charCodeAt(0).toString(16).padStart(4, '0'),
  );
}
